"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountableDrumrollNote = void 0;
const Note_1 = require("../Note");
/**
 * A special `Note` type which also contains a counter for how many times the
 * note needs to be hit in order to clear it. This is used for balloon and
 * kusudama notes.
 */
class CountableDrumrollNote extends Note_1.Note {
    constructor() {
        super(...arguments);
        this._count = 0;
    }
    get count() {
        return this._count;
    }
    set count(count) {
        this._count = count;
    }
}
exports.CountableDrumrollNote = CountableDrumrollNote;
